/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { groq } from 'next-sanity'
import { useRouter } from 'next/router'
import React from 'react'
import { AppLayout } from 'src/common/components/Layout/AppLayout'
import { urlFor } from 'src/common/lib/sanity/sanity'
import { getClient } from 'src/common/lib/sanity/sanity.server'
import { wrapper } from 'src/store'

const trainersQuery = groq`
 *[_type == "author"] {
	_id,
	name,
	"image": image.asset,
	"slug": slug.current,
 }
`

const TrainersIndexPage = ({ trainers }) => {
    const router = useRouter()
    return (
        <AppLayout pageTitle="Trainers">
            <div className="h-72 flex items-center justify-center relative overflow-hidden">
                <h1 className="capitalize font-medium text-4xl">Trainers</h1>
            </div>

            <div className=" pl-2 grid grid-cols-1 justify-items-center md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7 gap-x-3 gap-y-9">
                {trainers.map((trner, idx) => {
                    return (
                        <div
                            onClick={() => router.push(`trainers/${trner.slug}`)}
                            className="flex items-center justify-center flex-col hover:opacity-50 cursor-pointer"
                            key={idx}
                        >
                            <img
                                width="100px"
                                height="100px"
                                className="rounded-full mb-4"
                                src={urlFor(trner.image).width(100).height(100).url()}
                            />
                            <p>{trner.name}</p>
                        </div>
                    )
                })}
            </div>
        </AppLayout>
    )
}

export const getStaticProps = wrapper.getStaticProps(
    () =>
        async ({ preview = false }) => {
            const trainers = await getClient(preview).fetch(trainersQuery)

            return {
                props: { trainers, preview },
                revalidate: 600
            }
        }
)

export default TrainersIndexPage
